<template>
  <div class="settings-wrapper">
    <FiltersZone v-if="settingsHeadTitles.length > 1" no-options-button>
      <div slot="shortcuts" class="settings-wrapper__breadcrumbs v-centerer">
        <div
          v-for="(title, index) in settingsHeadTitles"
          :key="index"
          class="v-centerer"
          :style="title.style"
          @click="title.link != '' ? $router.push(title.link) : null"
        >
          {{ title.title }}
          <Icon v-show="title.nextImage" class="settings-wrapper__breadcrumbs__icon" rotate-left>
            {{ arrowDownLine }}
          </Icon>
        </div>
      </div>
    </FiltersZone>
    <div class="f-h-below-filters settings-wrapper__content">
      <div v-if="isSettingsHome" class="settings-wrapper__content__items">
        <SettingsItem
          v-for="setting in settings"
          :link="settingsTitlesObj[setting.id].path"
          :key="setting.id"
          :title="setting.title"
        />
      </div>
      <RouterView v-else />
    </div>
  </div>
</template>

<script>
// Components
import FiltersZone from '@/components/filters-zone.vue';
import Icon from '@/components/icon.vue';
import SettingsItem from '@/components/settings-item.vue';
// Utils
import { arrowDownLine } from '@/assets/icons';

export default {

  name: 'Settings',

  components: {
    FiltersZone,
    Icon,
    SettingsItem,
  },

  data() {
    return {
      arrowDownLine,
      settingsTitlesObj: {
        settings: { title: this.$t('message.SETTINGS'), path: '/settings' },
        main: { title: this.$t('message.SETTINGS_MAIN'), path: '/settings/main' },
        team: { title: this.$t('message.SETTINGS_TEAM'), path: '/settings/team' },
        'configurable-pages': { title: this.$t('message.CFG_PAGES'), path: '/settings/configurable-pages' },
        dashboard: { title: this.$t('message.SETTINGS_DASHBOARD'), path: '/settings/dashboard' },
        indicators: { title: this.$t('message.SETTINGS_INDICATORS'), path: '/settings/indicators' },
        problems: { title: this.$t('message.SETTINGS_PROBLEMS'), path: '/settings/problems' },
        actions: { title: this.$t('message.SETTINGS_ACTIONS'), path: '/settings/actions' },
        meetings: { title: this.$t('message.SETTINGS_MEETINGS'), path: '/settings/meetings' },
        'gemba-walks': { title: this.$t('message.GW_MENU'), path: '/settings/gemba-walks' },
      },
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS'),
    };
  },

  computed: {
    settings() {
      const commonSettings = [
        { id: 'main', title: this.$t('message.SETTINGS_MAIN') },
        { id: 'team', title: this.$t('message.SETTINGS_TEAM') },
        { id: 'configurable-pages', title: this.$t('message.CFG_PAGES') },
        { id: 'dashboard', title: this.$t('message.SETTINGS_DASHBOARD') },
        { id: 'indicators', title: this.$t('message.SETTINGS_INDICATORS') },
        { id: 'problems', title: this.$t('message.SETTINGS_PROBLEMS') },
        { id: 'actions', title: this.$t('message.SETTINGS_ACTIONS') },
        { id: 'meetings', title: this.$t('message.SETTINGS_MEETINGS') },
      ];
      if (this.currentTeam.accessGW === 1) {
        commonSettings.push({ id: 'gemba-walks', title: this.$t('message.GW_MENU') });
      }
      return commonSettings;
    },
    isSettingsHome() {
      const paths = this.$route.path.split('/');
      let str = '';
      for (let i = 0, len = paths.length; i < len; i++) {
        str += paths[i];
      }
      return str === 'settings';
    },
    /** Array: Successive titles when navigating inside the settings */
    settingsHeadTitles() { // Header of the settings page
      const paths = this.$route.path.split('/');
      const titles = [];
      // Remove empty strings and match non-empty strs to titles
      for (let i = 0, len = paths.length; i < len; i++) {
        const obj = this.settingsTitlesObj[paths[i]];
        if (typeof obj !== 'undefined') {
          titles.push({
            title: obj.title,
            link: obj.path,
            nextImage: true,
            style: 'cursor: pointer;',
          });
        }
      }
      // Current page title, is not a link
      if (titles.length > 0) {
        const lastIndex = titles.length - 1;
        titles[lastIndex].nextImage = false;
        titles[lastIndex].link = '';
        titles[lastIndex].style = '';
      }
      return titles;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.settings-wrapper {
  height: 100%;
  position: relative;

  .settings-dropdown:last-child {
    margin-bottom: 7em;
  }

  &.basic-gray-section {
    overflow: auto;
  }

  &__breadcrumbs {
    &__icon {
      width: .9rem;
      height: .9rem;
      margin: 0 1rem;
    }
  }

  &__content {
    &.f-h-below-filters {
      padding: $page-content-padding;
    }
  }
}
</style>
